import { createStore, applyMiddleware } from 'redux';
import RootReducer from './redurcers';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

const middleware = [thunk];

const store = createStore(RootReducer, composeWithDevTools(applyMiddleware(...middleware)));

export default store;